import checkout from "./form2";

const {
  formField2: {
    quarter,
    year,
    supplementaryForThe,
    firstTime,
    taxAgencyId,
    taxAgencyName,
  },
} = checkout;

const initialValues2 = {
  [quarter.name]: "",
  [year.name]: "",
  [supplementaryForThe.name]: "",
  [firstTime.name]: false,
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
};

export default initialValues2;
